import InvoiceAndPaymentMethods from './InvoiceAndPaymentMethods';

export default InvoiceAndPaymentMethods;